import { render, staticRenderFns } from "./AppAdd.vue?vue&type=template&id=460d19cb&scoped=true"
import script from "./AppAdd.vue?vue&type=script&lang=js"
export * from "./AppAdd.vue?vue&type=script&lang=js"
import style0 from "./AppAdd.vue?vue&type=style&index=0&id=460d19cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d19cb",
  null
  
)

export default component.exports